import { useState } from "react";
import "./Permissions.sass";
const PermissionCard = ({
  permissions,
  name,
  title,
  setCheckedPermission,
  setPermissions
}) => {

  const HandlePermission = (name) => {
  setPermissions((prev) => ({
    ...prev,
    [name]: !prev[name],
  }));
};
  return (
    <>
      <div className="permissions">
        <div className="permission_card_title">
          <p>{title}</p>
        </div>
        <div className="permission-check_list">
          <input
            type="checkbox"
            name={name}
            checked={permissions?.[name]}
            onChange={(e) =>{
              setCheckedPermission({ [e.target.name]: e.target.checked })
              HandlePermission(name)}
            }
          />
          <span>Grant</span>
        </div>
      </div>
    </>
  );
};

export default PermissionCard;
